/**
 * Quantity input: find all [data-qty-input] containers and wire up
 * [data-qty-input-decrease] / [data-qty-input-increase] to the inner
 * [data-qty-input-value] number input.
 */
function initQtyInputs() {
  document.querySelectorAll('[data-qty-input]').forEach((container) => {
    if (container.dataset.qtyInputReady === '1') return;

    const input = container.querySelector('[data-qty-input-value]');
    const decreaseBtn = container.querySelector('[data-qty-input-decrease]');
    const increaseBtn = container.querySelector('[data-qty-input-increase]');
    if (!input || !decreaseBtn || !increaseBtn) return;

    container.dataset.qtyInputReady = '1';

    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const allowZero = container.hasAttribute('data-qty-input-allow-zero');

    function getMax() {
      if (!input.hasAttribute('max')) return null;
      const max = parseInt(input.getAttribute('max'), 10);
      return Number.isFinite(max) ? max : null;
    }

    function getValue() {
      const value = parseInt(input.value, 10);
      return Number.isFinite(value) ? value : min;
    }

    function updateButtons() {
      const max = getMax();
      const value = getValue();
      const decreaseDisabled = allowZero ? value <= 0 : value <= min;
      const increaseDisabled = max != null ? value >= max : false;

      decreaseBtn.disabled = decreaseDisabled;
      increaseBtn.disabled = increaseDisabled;
      decreaseBtn.setAttribute(
        'aria-disabled',
        decreaseDisabled ? 'true' : 'false'
      );
      increaseBtn.setAttribute(
        'aria-disabled',
        increaseDisabled ? 'true' : 'false'
      );
    }

    function clampInputValue() {
      const value = parseInt(input.value, 10);
      if (!Number.isFinite(value)) {
        updateButtons();
        return;
      }

      if (allowZero && value === 0) {
        updateButtons();
        return;
      }

      const max = getMax();
      let clampedValue = Math.max(min, value);
      if (max != null) clampedValue = Math.min(max, clampedValue);

      if (clampedValue !== value) input.value = clampedValue;
      updateButtons();
    }

    function changeValue(delta) {
      if (delta > 0 && increaseBtn.disabled) return;
      if (delta < 0 && decreaseBtn.disabled) return;

      const max = getMax();
      let value = getValue();

      if (allowZero && value === min && delta === -1) {
        input.value = 0;
        updateButtons();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      value = Math.max(allowZero ? 0 : min, value + delta);
      if (max != null) value = Math.min(max, value);
      input.value = value;
      updateButtons();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    decreaseBtn.addEventListener('click', () => changeValue(-1));
    increaseBtn.addEventListener('click', () => changeValue(1));
    input.addEventListener('input', clampInputValue);
    input.addEventListener('change', () => {
      if (allowZero && getValue() === 0) {
        updateButtons();
        return;
      }
      if (!input.value) input.value = min;
      clampInputValue();
    });

    // Keep buttons in sync when product-purchase (or other JS) changes max later
    const maxObserver = new MutationObserver(() => clampInputValue());
    maxObserver.observe(input, {
      attributes: true,
      attributeFilter: ['max'],
    });

    clampInputValue();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQtyInputs);
} else {
  initQtyInputs();
}
